import { Link as RouterLink } from "react-router-dom-v5-compat";
import {
  AppBar,
  Box,
  Button,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";
import MenuIcon from "../../icons/Menu";
import useHelp from "../../help/useHelp";
export default function DocsNavbar({ onSidebarMobileOpen }) {
  const { brand } = useHelp();
  return (
    <AppBar
      position="fixed"
      color="inherit"
      elevation={0}
      sx={{
        borderBottom: 1,
        borderColor: "divider",
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <Toolbar sx={{ gap: 2 }}>
        <IconButton
          aria-label="Open guide navigation"
          onClick={onSidebarMobileOpen}
          sx={{ display: { lg: "none" } }}
        >
          <MenuIcon />
        </IconButton>
        {brand.logo && (
          <Box
            component="img"
            src={brand.logo}
            alt={brand.name}
            sx={{
              display: { xs: "none", sm: "block" },
              maxWidth: 150,
              maxHeight: 36,
              objectFit: "contain",
            }}
          />
        )}
        <Typography
          component={RouterLink}
          to="/docs"
          variant="h6"
          sx={{ color: brand.color, textDecoration: "none", flexGrow: 1 }}
        >
          Help Centre
        </Typography>
        <Button component={RouterLink} to="/dashboard/assets" color="inherit">
          Back to platform
        </Button>
      </Toolbar>
    </AppBar>
  );
}
